module.exports = __webpack_public_path__ + "static/media/amulet_11.6ae09113.png";